import { InjectionToken } from '@angular/core';
import { NirbyEnvironment } from './environment.type';

export const CREATORS_ENVIRONMENT = new InjectionToken<NirbyEnvironment>('AppConfig');

export { NirbyEnvironment } from './environment.type';
export * from './localhost';
